import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=b2c89400&"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordView.vue?vue&type=style&index=0&id=b2c89400&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports